export default function jitter(callback, maxDelay = 1000) {
    return new Promise((resolve) => {
        const random = Math.random() * maxDelay;
        const delay = Math.floor(random);
        return setTimeout(resolve(callback), delay);
    });
}
